import React, { useState } from "react";
export default function CommercialRetention({ api }) {
  const [settings, setSettings] = useState(null),
    [preview, setPreview] = useState(null),
    [reason, setReason] = useState(""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [done, setDone] = useState(null);
  const run = async (action) => {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await action();
    } catch (e) {
      setError(e.response?.data?.message || "Opération impossible.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <details
      className="rounded-xl border p-3"
      onToggle={(e) => {
        if (e.currentTarget.open && !settings)
          run(async () => {
            const { data } = await api.get("commercial/retention");
            setSettings(data);
          });
      }}
    >
      <summary>Conservation des coordonnées et notes CRM</summary>
      <div className="mt-3 space-y-3">
        <p>
          L’effacement est manuel et désactivé par défaut. Les dossiers
          contractuels ou comptables, devis et tâches ouvertes sont protégés.
          Les exclusions et oppositions restent conservées.
        </p>
        {settings && (
          <>
            <label className="block">
              <input
                type="checkbox"
                checked={settings.policy.enabled}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    policy: { ...settings.policy, enabled: e.target.checked },
                  })
                }
              />{" "}
              Autoriser l’effacement après prévisualisation
            </label>
            <label className="block">
              Durée d’inactivité avant effacement (jours)
              <input
                type="number"
                className="w-full rounded-lg border bg-white p-2"
                min="30"
                max="36500"
                value={settings.policy.inactiveProspectDays}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    policy: {
                      ...settings.policy,
                      inactiveProspectDays: Number(e.target.value),
                    },
                  })
                }
              />
            </label>
            <button
              type="button"
              className="secondary"
              disabled={busy}
              onClick={() =>
                run(async () => {
                  const { data } = await api.post(
                    "commercial/retention/policy",
                    {
                      policy: settings.policy,
                      expectedVersion: settings.version,
                    },
                  );
                  setSettings(data);
                  setPreview(null);
                })
              }
            >
              Enregistrer la politique
            </button>
            <button
              type="button"
              className="secondary"
              disabled={busy}
              onClick={() =>
                run(async () => {
                  const { data } = await api.post(
                    "commercial/retention/preview",
                  );
                  setPreview(data);
                  setDone(null);
                })
              }
            >
              Prévisualiser les données concernées
            </button>
          </>
        )}
        {preview && (
          <div className="rounded-lg bg-amber-50 p-3 space-y-2">
            <p>{preview.scope}</p>
            <p>
              {preview.clients.length} prospect(s) proposé(s), par lot de{" "}
              {preview.limit} maximum · {preview.protectedCount} dossier(s)
              protégé(s).
            </p>
            <ul>
              {preview.clients.map((c) => (
                <li key={c.id}>
                  {c.name} · {c.siret || "SIRET absent"}
                </li>
              ))}
            </ul>
            <p>
              Les fenêtres déjà ouvertes devront être rechargées après
              l’opération. Les anciennes sauvegardes seront refusées.
            </p>
            <label className="block">
              Justification
              <textarea
                className="w-full rounded-lg border bg-white p-2"
                value={reason}
                maxLength={1000}
                onChange={(e) => setReason(e.target.value)}
              />
            </label>
            <button
              type="button"
              className="secondary"
              disabled={
                busy ||
                !preview.enabled ||
                !preview.clients.length ||
                !reason.trim()
              }
              onClick={() =>
                run(async () => {
                  const { data } = await api.post(
                    "commercial/retention/execute",
                    { expectedVersion: preview.version, reason },
                  );
                  setDone(data.count);
                  setPreview(null);
                })
              }
            >
              Confirmer l’effacement de ces coordonnées et notes
            </button>
          </div>
        )}
        {done != null && (
          <>
            <p role="status">
              Coordonnées et notes effacées pour {done} prospect(s).
            </p>
            <button type="button" onClick={() => window.location.reload()}>
              Recharger le portefeuille
            </button>
          </>
        )}
        {busy && <p role="status">Traitement…</p>}
        {error && (
          <p role="alert" className="text-red-700">
            {error}
          </p>
        )}
      </div>
    </details>
  );
}
